import { render } from "./TheHeader.vue?vue&type=template&id=71c020a0&scoped=true&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=71c020a0&scoped=true&lang=less"

import exportComponent from "/mnt/f/Projects/Vue/typescript-neo/neo-sanctum/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c020a0"]])

export default __exports__